const TERMS_OF_USE_AND_SALE = 'https://legal.fabfitfun.com/#terms-of-use';
const MEMBERSHIP_TERMS = 'https://legal.fabfitfun.com/#box-membership-terms';
const PRIVACY_POLICY = 'https://legal.fabfitfun.com/#privacy-policy';
const FABFITFUN_SUPPORT =
  'https://support.fabfitfun.com/?a=How-can-I-contact-Customer-Care---id--2tnlqvo8SqWH7h_ujSe5NQ';
const MORE_DETAILS =
  'https://support.fabfitfun.com/hc/en-us/articles/360035968991-What-s-your-cancellation-policy-';
const LEARN_MORE =
  'https://support.fabfitfun.com/hc/en-us/articles/360035609492';
const BILLING = 'https://support.fabfitfun.com/?a=BillingShipping-Schedule---id--fQP9JA7KS6-9PdDGQIL0oQ';
const SUPPORT = 'https://support.fabfitfun.com';
const CANCEL_POLICY = 'https://support.fabfitfun.com/?a=What%27s-your-cancellation-policy---id--EfNjm6RJT0SjdirIVrfbgg';

export {
  TERMS_OF_USE_AND_SALE,
  MEMBERSHIP_TERMS,
  PRIVACY_POLICY,
  FABFITFUN_SUPPORT,
  MORE_DETAILS,
  LEARN_MORE,
  BILLING,
  SUPPORT,
  CANCEL_POLICY
};
